<script>
export default {
  data() {
    return {
      configuration: JSON.parse(localStorage.getItem("configuration")),
    };
  },
};
</script>
<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="text-sm-end d-none d-sm-block">
            Copyright ©
            {{ new Date().getFullYear() }}
            PLN Corpu - UPS. All Rights Reserved.
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- end footer -->
</template>
